module.exports = __webpack_public_path__ + "media/images/categories/icon_cat9-e40159d4a151a0a59cdfd526fcbda092.svg";